(() => {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (root.hasAttribute('data-ready')) return;

    const viewport = root.querySelector('.lp-slider');
    const dotList = root.querySelector('.lp-dots');
    const status = root.querySelector('[data-lp-carousel-status]');
    const prev = root.querySelector('[data-lp-carousel-prev]');
    const next = root.querySelector('[data-lp-carousel-next]');
    const dots = dotList ? Array.from(dotList.querySelectorAll('.lp-dots__dot')) : [];
    if (!viewport) return;

    const slides = () => Array.from(root.querySelectorAll('.lp-slider__slide'));

    const pitch = (list) => {
      if (!list.length) return 0;

      return list.length > 1
        ? list[1].offsetLeft - list[0].offsetLeft
        : list[0].getBoundingClientRect().width;
    };

    const end = () => viewport.scrollWidth - viewport.clientWidth;

    const lastIndex = (list) => {
      const step = pitch(list);
      if (step <= 0) return 0;

      return Math.min(list.length - 1, Math.round(end() / step));
    };

    const activeIndex = (list) => {
      const step = pitch(list);
      const index = step > 0 ? Math.round(viewport.scrollLeft / step) : 0;

      return Math.min(lastIndex(list), Math.max(0, index));
    };

    const sync = () => {
      const list = slides();
      if (dotList) dotList.hidden = end() <= 1;

      const last = lastIndex(list);
      const active = activeIndex(list);

      dots.forEach((dot, position) => {
        dot.hidden = position > last;
        dot.setAttribute('aria-current', position === active ? 'true' : 'false');
      });

      if (prev) prev.disabled = active <= 0;
      if (next) next.disabled = active >= last;

      if (status) {
        status.textContent = list.length
          ? status
              .getAttribute('data-lp-carousel-status')
              .replace('[index]', active + 1)
              .replace('[total]', list.length)
          : '';
      }
    };

    const scrollTo = (index, instant) => {
      const list = slides();
      const slide = list[index];
      if (!slide) return;

      const last = lastIndex(list);
      const left = index >= last ? end() : slide.offsetLeft - list[0].offsetLeft;

      viewport.scrollTo({ left: left, behavior: instant || REDUCED.matches ? 'auto' : 'smooth' });
    };

    const stepBy = (direction) => scrollTo(activeIndex(slides()) + direction);

    dots.forEach((dot, index) => dot.addEventListener('click', () => scrollTo(index)));
    if (prev) prev.addEventListener('click', () => stepBy(-1));
    if (next) next.addEventListener('click', () => stepBy(1));

    viewport.addEventListener('scroll', sync, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(viewport);

    root.addEventListener('lp-carousel:goto', (event) => {
      scrollTo(event.detail.index, event.detail.instant);
      sync();
    });

    root.addEventListener('shopify:block:select', (event) => {
      const index = slides().indexOf(event.target.closest('.lp-slider__slide'));
      if (index >= 0) scrollTo(index);
    });

    sync();
    root.setAttribute('data-ready', '');
  };

  const initAll = (scope) => {
    if (scope instanceof Element && scope.matches('[data-lp-carousel]')) init(scope);
    scope.querySelectorAll('[data-lp-carousel]').forEach(init);
  };

  initAll(document);

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initAll(event.target);
  });
})();
